import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { deactivateSubscriptionUser, getActiveSubscriptionUsers } from "../../../../features/state/StateSubscriptionUser-slice";
import { GenerateSubUserManagementColumns } from "../../../../components/stateful/table/TableHelper";

export const useUserSubManagementController = () => {
  const dispatch = useAppDispatch();

  const activeUsers = useAppSelector((state) => state.subscriptionUser.activeUsers);
  const loading = useAppSelector((state) => state.subscriptionUser.fetchingActiveUsers);
  const refreshRequired = useAppSelector((state) => state.subscriptionUser.refreshRequired);

  useEffect(() => {
    if (activeUsers.length < 1) {
      dispatch(getActiveSubscriptionUsers());
    }

    if (columns.length < 1) {
      defineColumns();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (refreshRequired) {
      dispatch(getActiveSubscriptionUsers());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshRequired]);

  const [columns, setColumns] = useState<any>([]);

  const defineColumns = () => {
    setColumns(GenerateSubUserManagementColumns());
  }

  const deactivate = (user: any) => {
    dispatch(deactivateSubscriptionUser(user.id));
  }

  return {
    activeUsers,
    loading,
    columns,
    deactivate
  }
}